import { useTranslation } from "react-i18next";
import ServiceImg from '@/assets/images/pillar-service.jpg'

const getInvestmentServices = (t: (key: string) => string) => [
  { icon: "ri-global-line", title: t("investService1Title"), desc: t("investService1Desc") },
  { icon: "ri-links-line", title: t("investService2Title"), desc: t("investService2Desc") },
  { icon: "ri-bar-chart-2-line", title: t("investService3Title"), desc: t("investService3Desc") },
  { icon: "ri-map-2-line", title: t("investService4Title"), desc: t("investService4Desc") },
];

export default function ServiceInvestment() {
  const { t } = useTranslation();
  const investmentServices = getInvestmentServices(t);

  return (
    <section id="service-3" className="bg-white py-20 lg:py-24">
      <div className="w-full px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative rounded-3xl overflow-hidden h-80 lg:h-[480px]">
            <img
              src={ServiceImg}
              alt="Investment Facilitation"
              loading="lazy"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 rounded-xl px-5 py-4">
              <p className="text-[#0A1628] font-bold text-sm">{t("investCardTitle")}</p>
              <p className="text-gray-500 text-xs mt-0.5">{t("investCardDesc")}</p>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0A1628] rounded-xl">
                <i className="ri-funds-line text-2xl text-white" />
              </div>
              <span className="text-xs font-semibold tracking-widest uppercase text-[#00C2C2]">{t("investServiceNum")}</span>
            </div>
            <h2 className="text-4xl font-bold text-[#0A1628] leading-tight mb-4">
              {t("investTitle")}<br />{t("investSubtitle")}
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">
              {t("investDesc")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {investmentServices.map((s) => (
                <div key={s.title} className="flex gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#f8fafc] rounded-lg shrink-0">
                    <i className={`${s.icon} text-base text-[#00C2C2]`} />
                  </div>
                  <div>
                    <h4 className="text-[#0A1628] font-bold text-sm mb-1">{s.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-[#00C2C2] text-white text-sm font-bold px-7 py-3.5 rounded-full hover:bg-[#00AAAA] transition-all whitespace-nowrap cursor-pointer"
              >
                {t("investCta")} <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
